import { fetchNewestProjectsSsr } from '@/features/pages/home/api';
import { type Locale } from '@/config/i18n/locales';
import { IndividualProject } from './IndividualProject';
import { inheritSsrContext } from '@/lib/ssrRequestContext';
import { StructuredData } from '@/components/common/StructuredData/StructuredData';
import { generateNewestProjectsSchema } from '@/common';

type IndividualProjectAsyncProps = {
  locale: Locale;
  pageId: string;
};

export const IndividualProjectAsync = async ({ locale, pageId }: IndividualProjectAsyncProps) =>
  inheritSsrContext(pageId, 'home:ssr', async () => {
    const data = await fetchNewestProjectsSsr(locale);
    const schemas = data?.length ? generateNewestProjectsSchema(data, locale) : null;
    return (
      <>
        {schemas?.length ? <StructuredData data={schemas} /> : null}
        <IndividualProject data={data} />
      </>
    );
  });
